import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";

import {
    REQUEST_SOURCEPROXY_ADD,
    REQUEST_SOURCEPROXY_CONFIG,
    REQUEST_SOURCEPROXY_REMOVE,
    REQUEST_SOURCEPROXY_UPDATE,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/config/sourceProxyMsgDefinitions";
import { SourceProxySettings, SourceProxyID } from "userful-chronos-app-common-js/dist/models/config/sourceProxy";
import "./sourceProxyMsgReciever";

export const requestSourceProxyConfig = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_SOURCEPROXY_CONFIG);
};

export const requestAddSourceProxy = (payload: SourceProxySettings) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_SOURCEPROXY_ADD, payload);
};

export const requestUpdateSourceProxy = (payload: SourceProxySettings) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_SOURCEPROXY_UPDATE, payload);
};

export const requestRemovePassport = (payload: SourceProxyID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_SOURCEPROXY_REMOVE, payload);
};
